'use strict';

/*global app*/
/*global services*/
/*global resSuccess*/
/*global resError*/
/*global invokeCallback*/

function HandlingUnitService() {
  this.modal = null;

  this.init();
}

HandlingUnitService.prototype = $.extend({}, {
  constructor: 'HandlingUnitService',

  registerCallbacks: function registerCallbacks() {
    var _this = this;

    return _this;
  },

  //----------------------------------------------------------------------------

  isHandlingUnitValid: function isHandlingUnitValid(RID, params, callback) {
    var _this = this;

    params.RID = RID;

    app.getFormation('handling_unit:is_valid', params, function (res) {
      if (res.msg === 'SUCCESS') {
        invokeCallback(callback, res.data);
      } else {
        app.viewErrorMessage(res.error);
      }
    });

    return _this;
  },

  getStockQuantity: function getStockQuantity(RID, callback) {
    var _this = this;

    app.getFormation('handling_unit:get_stock_quantity', { RID: RID }, function (res) {
      if (res.msg === 'SUCCESS') {
        invokeCallback(callback, resSuccess, res.data);
      } else {
        app.viewErrorMessage(res.error, function () {
          invokeCallback(callback, resError);
        });
      }
    });

    return _this;
  },

  //----------------------------------------------------------------------------

  init: function init() {
    var _this = this;

    _this.modal = services.get('modal-handling-unit');

    _this.registerCallbacks();

    return _this;
  }
});
